

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop, VModel} from "vue-property-decorator";
import {namespace} from "vuex-class";
import {IStandaloneDeviceTypeOption} from "@/model/Standalone/standaloneInterfaces";

const standaloneModule = namespace("standaloneModule");

@Component({})
export default class NewStandaloneDialog extends Vue {

  @standaloneModule.Action('createNewStandalone')
  private createNewStandaloneAction!: ({ communityId, digitalPortalType }: { communityId: number; digitalPortalType: string }) => Promise<boolean>;

  @standaloneModule.Action('fetchDeviceTypeOptions')
  private fetchDeviceTypeOptions!: () => void;

  @standaloneModule.Getter('deviceTypeOptions')
  private deviceTypeOptions!: IStandaloneDeviceTypeOption[];

  @VModel()
  protected dialogShowing!: boolean;

  @Prop({ type: Number, default: 0 })
  private communityId!: number;

  protected loading: boolean = false;
  private error: boolean = false;
  private valid: boolean = false;
  private digitalPortalType: string = '';

  public created() {
    this.fetchDeviceTypeOptions();
  }

  protected get typeItems(): IStandaloneDeviceTypeOption[] {
    return this.deviceTypeOptions;
  }

  protected onSubmit() {
    this.loading = true;
    this.error = false;
    this.createNewStandaloneAction({ communityId: this.communityId, digitalPortalType: this.digitalPortalType })
      .then((resp) => {
        this.loading = false;
        if (!resp) {
          this.error = true;
          return;
        }
        this.$router.go(0);
      })
      .catch((err: any) => {
        this.loading = false;
        this.error = true;
      });
  }

  protected onCancel() {
    this.error = false;
    this.dialogShowing = false;
  }

}
